export default "__VITE_ASSET__DmmTlnr8__"